import React, { lazy } from 'react'
import Sherpa, { TYPE_LARGE } from '../Sherpa/index'

const LoadableSearch = lazy(
  () => import('../SearchPage/index'),
  { fallback: <Sherpa type={TYPE_LARGE} /> },
)

// AP-19618: previously this switch fired `experiment_exposure` for the
// unified-search-web experiment on /search views. The experiment was stopped
// 2026-09-28 (conclusion: lost) and all its PostHog wiring was removed, so
// this is now a plain lazy mount of the search page.
export default function SearchPageSwitch (props) {
  return <LoadableSearch location={props.location} history={props.history} />
}
